module.exports = __webpack_public_path__ + "static/media/lily-carter.9f90dc45.jpg";